import { useField } from 'react-final-form';
import { useFieldArray } from 'react-final-form-arrays';

import { type TBlock } from '@wp-block-builder/blocks/types';

export function useEditableBlock(name: string) {
  return useEditableBlockInput(name).value;
}

export function useEditableBlockInput(name: string) {
  return useField<TBlock>(name).input;
}

export function useEditableBlocks(name: string) {
  return useField<TBlock[]>(name).input.value;
}

type TArrayField = ReturnType<typeof useFieldArray<TBlock>>;
export function useEditableBlocksArrayField(name: string): TArrayField['fields'] {
  return useFieldArray<TBlock>(name).fields;
}
